import React, { useEffect, useState } from "react";
import {
  getSupportCategories,
  removeSupportCategories,
} from "../../../Controllers/AppManagement/helpSupport";
import mainContext from "../../../contexts/mainContext";
import { __snackBarSeverity } from "../../../constants";
import moment from "moment";
import { Button, Divider, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import styled from "@emotion/styled";
import AddEditCategory from "./AddEditCategory";
import DeleteIcon from "@mui/icons-material/Delete";
export default function Categories() {
  const { setSnackBar, setProfileNavTitle } =
    React.useContext(mainContext); /* App State */
  const [state, setState] = useState({
    /* Component State */ supportCategory: [],
    openModal: false,
    selectedData: {},
    index: -1,
    deleteConfirmOpen: false,
    itemToDelete: null,
  });

  useEffect(() => {
    setProfileNavTitle("Help&Support"); /* Set TopNav Title */
    fetchCategories();
    // eslint-disable-next-line
  }, []);

  const callSnackBar = (msg, type) => {
    /* Alert for User */
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type],
    });
  };

  const fetchCategories = async () => {
    /* Get Categories and sub categories */
    const res = await getSupportCategories();
    if (res.data.status === 200) {
      setState({ ...state, ...res.data.data });
    } else {
      callSnackBar(res.data.errors[0].message, "error");
    }
  };

  const handleAdd = (data) => {
    let temp = [...state.supportCategory];
    temp.push(data);
    setState({ ...state, supportCategory: temp, openModal: false });
  };

  const handleSilentEdit = (data, index) => {
    let temp = [...state.supportCategory];
    temp[index] = data;
    setState({ ...state, supportCategory: temp });
  };

  const handleEdit = (data, index) => {
    let temp = [...state.supportCategory];
    temp[index] = data;
    setState({ ...state, supportCategory: temp, openModal: false });
  };

  const confirmDelete = async () => {
    if (!state.itemToDelete) return;
    const { index, id } = state.itemToDelete;
    const res = await removeSupportCategories({ categoryId: id });
    if (res.data.status === 200) {
      callSnackBar(res.data.message, "success");
      let temp = [...state.supportCategory];
      temp.splice(index, 1);
      setState({ ...state, supportCategory: temp, openModal: false, deleteConfirmOpen: false, itemToDelete: null });
    } else {
      callSnackBar(res.data.errors[0].message);
      setState({ ...state, deleteConfirmOpen: false, itemToDelete: null });
    }
  };

  const handleRemove = (index, id) => {
    setState({ ...state, deleteConfirmOpen: true, itemToDelete: { index, id } });
  };

  return (
    <>
      <Conatiner>
        <Header>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              setState({
                ...state,
                openModal: true,
                selectedData: {},
                index: -1,
              });
            }}
          >
            Add new
          </Button>
        </Header>
        <Body>
          <List>
            <div className="header">Category</div>
            <div className="header">Sub-categories</div>
            <div>Updated On</div>
          </List>
          <Divider className="divider-gap" />
          {state.supportCategory.map((object, index) => {
            return (
              <List key={object._id}>
                <div>{object.category}</div>
                <div>
                  {object.subCategory.map((object1, index) => (
                    <span>
                      {object1.name}{" "}
                      {object.subCategory.length !== index + 1 && " , "}
                    </span>
                  ))}
                </div>
                <div>{moment(object.updatedAt).format("DD MMM, YYYY")}</div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <DeleteIcon
                    className="pointer"
                    sx={{ marginRight: 2 }}
                    onClick={() => handleRemove(index, object._id)}
                  />
                  <button
                    className="list_card_view_btn"
                    onClick={() => {
                      setState({
                        ...state,
                        openModal: true,
                        selectedData: object,
                        index,
                      });
                    }}
                  >
                    Edit
                  </button>
                </div>
              </List>
            );
          })}
        </Body>
      </Conatiner>

      {/* Render Add/Edit Category Popup */}
      {state.openModal && (
        <AddEditCategory
          open={state.openModal}
          index={state.index}
          data={state.selectedData}
          onAdd={handleAdd}
          onEdit={handleEdit}
          onSilentEdit={handleSilentEdit}
          handleClose={() => {
            setState({ ...state, openModal: false });
          }}
        />
      )}

      {/* Render Delete Confirm Dialog */}
      <Dialog
        open={state.deleteConfirmOpen}
        onClose={() => setState({ ...state, deleteConfirmOpen: false, itemToDelete: null })}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this category?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setState({ ...state, deleteConfirmOpen: false, itemToDelete: null })}
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const Conatiner = styled("div")`
  .divider-gap {
    margin: 0.5rem 0;
  }
  button {
    text-transform: none;
  }
`;

const Header = styled("div")`
  button {
    border-radius: 5px;
  }
`;
const Body = styled("div")`
  height: 80vh;
`;

const List = styled("div")`
  .header {
    font-family: "semi-bold";
    font-size: 90%;
  }
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 2fr 8fr 2fr 1fr;
  align-items: center;
  font-size: 14px;
`;
